import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-version-checker',
  template: `<ion-content class="ion-padding" scroll-y="false">
    @if(!forceUpdate) {
    <ion-fab vertical="top" horizontal="start" slot="fixed" style="top: max(16px, var(--ion-safe-area-top))">
      <ion-fab-button (click)="close()" color="light">
        <ion-icon name="close-outline" color="primary"></ion-icon>
      </ion-fab-button>
    </ion-fab>
    }

    <div class="container">
      <ion-icon name="arrow-up-circle-outline" class="update-icon"></ion-icon>
      <h2>Nueva versión disponible</h2>
      <p>Por favor actualiza a la última versión</p>

      <ion-button expand="block" (click)="openStore()" class="update-btn">Actualizar ahora</ion-button>
    </div>
  </ion-content>`,
  styles: `
  .container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 0 16px;
}

.update-icon {
  font-size: 72px;
  color: var(--ion-color-light);
  margin-bottom: 24px;
}

h2 {
  font-weight: bold;
  font-size: 22px;
  margin: 0;
}

p {
  font-size: 16px;
  margin-top: 8px;
  margin-bottom: 32px;
  color: var(--ion-color-medium);
}

.update-btn {
  margin-bottom: 40px;
}

  `,
  standalone: false,
})
export class VersionCheckerComponent {
  @Input() forceUpdate: boolean;

  constructor(private modalCtrl: ModalController) {}

  close() {
    this.modalCtrl.dismiss();
  }

  openStore() {
    const appStoreUrl = 'https://apps.apple.com/us/app/psp-servicios-policiales/id6739888552';
    const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.policiard.psp';
    const url = Capacitor.getPlatform() === 'ios' ? appStoreUrl : playStoreUrl;
    window.open(url, '_blank');
  }
}
